import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <section className="w-full bg-white py-32 px-6" data-id="element-2">
      <div className="max-w-4xl mx-auto text-center" data-id="element-3">
        <FadeIn data-id="element-4">
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-6" data-id="element-5">
            Launch in weeks, not months. 
          </h2>
          <p className="text-xl text-neutral-500 mb-10 max-w-2xl mx-auto" data-id="element-6">
            It takes about 3 minutes. We’ll review your requirements and respond
            with a preliminary milestone plan.
          </p>
          <Button variant="primary" className="px-10 py-5 text-lg" icon data-id="element-7">
            Start your project brief
          </Button>
        </FadeIn>
      </div>
    </section>;
}